import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { contentFor, setContent, metaFor, normalize } from "@/seo/meta";
import { applyMeta } from "@/seo/RouteMeta";

export const IMG = { pod: "pod", vintage: "vintage", handmade: "handmade" };
export const imageFor = (category) => `/images/content/${IMG[category] || "guides"}.webp`;
export const CATEGORY_LABELS = {
  basics: "Etsy SEO basics", "big-catalogs": "Big catalogs", pod: "Print on demand", vintage: "Vintage", seasonal: "Seasonal",
  tools: "Tools & workflows", handmade: "Handmade",
};

// Static HTML ships the data inline (window.__AT_CONTENT__); pages published after the last build load from the API.
export const useContent = (url, revalidate = false) => {
  const { pathname } = useLocation();
  const key = normalize(pathname);
  const [data, setData] = useState(() => contentFor(key) || null);
  useEffect(() => {
    const hit = contentFor(key);
    const cached = hit && !(hit.published_at && Date.parse(hit.published_at) > Date.now()) ? hit : null;
    if (cached) {
      setData(cached);
      if (!revalidate) return;
    } else {
      setData(null);
    }
    api.get(url).then((r) => { setContent(key, r.data); setData(r.data); if (!cached) applyMeta(metaFor(key)); })
      .catch((e) => {
        if (cached) return;
        // Only a definitive 404 from the content API may mark the page not found (noindex). Slow or failed calls keep the
        // embedded pre-rendered data (or the loading state) and never touch robots.
        if (e?.response?.status !== 404) {
          if (hit) setData(hit);
          else setTimeout(() => api.get(url).then((r) => { setContent(key, r.data); setData(r.data); applyMeta(metaFor(key)); })
            .catch(() => setData({ loadError: true })), 2000);
          return;
        }
        const nf = { notFound: true, scheduled: e.response.data?.detail === "Not published yet." };
        setContent(key, nf); setData(nf); applyMeta(metaFor(key));
      });
  }, [key, url, revalidate]);
  return data;
};

export const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" });
